import { Navigate } from 'react-router-dom'
import { adminAuth } from '../services/adminAuth'

interface AdminRouteProps {
  children: JSX.Element
}

export function AdminRoute({ children }: AdminRouteProps) {
  if (!adminAuth.isAuthenticated()) {
    return <Navigate to="/admin/login" replace />
  }

  return children
}
